import React from 'react';



import CourseQuizApp from './CourseQuizApp';


function CourseQuizScreen () {
 
    return (
      <div className="App">          
      
        <CourseQuizApp></CourseQuizApp>
      </div>
    );
  }


export default CourseQuizApp;
